// src/reducers/validationReducer.ts
export interface ValidationState {
  showValidationErrors: boolean;
  stepErrors: Record<number, string[]>;
}

export type ValidationAction =
  | { type: 'INIT_VALIDATION_STATE' }
  | { type: 'SHOW_VALIDATION_ERRORS'; payload: boolean }
  | { type: 'SET_STEP_ERRORS'; payload: { stepIndex: number; errors: string[] } }
  | { type: 'TOGGLE_VALIDATION_ERRORS' };

const initialState: ValidationState = {
  showValidationErrors: false,
  stepErrors: {}
};

export default function validationReducer(
  state: ValidationState = initialState,
  action: ValidationAction
): ValidationState {
  switch (action.type) {
    case 'INIT_VALIDATION_STATE':
      return initialState;
    case 'SHOW_VALIDATION_ERRORS':
      return { ...state, showValidationErrors: action.payload };
    case 'SET_STEP_ERRORS':
      return {
        ...state,
        stepErrors: {
          ...state.stepErrors,
          [action.payload.stepIndex]: action.payload.errors
        }
      };
    case 'TOGGLE_VALIDATION_ERRORS':
      return {
        ...state,
        showValidationErrors: !state.showValidationErrors
      };
    default:
      return state;
  }
}
